import i18next from 'i18next';

i18next.addResources('es_CL', 'ConfirmedOrderModal', {
  modalTitle: 'Orden exitosa',
  modalDescription:
    'Presione el botón para continuar creando ordenes ó espere para ser redirigido automáticamente',
  buttonBack: 'Volver a nueva orden'
});
